
import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { ExBundleAssignmentVM } from "@/interfaces/ExBundleAssignmentVM";


const globals = namespace("globals");

@Component({
    components: {}
})
export default class ExBundleStatus extends Vue {
  @Prop() bundleAssignment!: ExBundleAssignmentVM;
  @Prop() isGroupAdmin!: boolean;
  @Prop({ default: false }) showInRow!: boolean;

  // $refs!: {};

  mounted() {
    this.disableRatingFocus();
  }

  updated() {
    // Also run after updates in case rating is re-rendered
    this.$nextTick(() => {
      this.disableRatingFocus();
    });
  }

  disableRatingFocus() {
    // Find all rating buttons and make them non-focusable. Be defensive: some renderings make `$el` a component
    // instead of a raw DOM node, so prefer a ref and verify `querySelectorAll` exists before calling it.
    this.$nextTick(() => {
      const possibleRoot: any = (this.$refs.root as HTMLElement) || this.$el;
      const rootEl: any = possibleRoot && (typeof possibleRoot.querySelectorAll === 'function' ? possibleRoot : (possibleRoot && possibleRoot.$el ? possibleRoot.$el : null));
      if (!rootEl) return;
      const ratingButtons = rootEl.querySelectorAll('.v-rating button, .v-rating .v-icon');
      ratingButtons.forEach((button: any) => {
        button.tabIndex = -1;
        button.style.pointerEvents = 'none';
        button.setAttribute('aria-hidden', 'true');
        button.removeAttribute('aria-label');
      });
    });
  }

  get isCertified() {
    if (!this.bundleAssignment?.exBundle)
      return false;

    if (this.bundleAssignment.exBundle.hasSignature && this.bundleAssignment.isSigned)
      return true;
    if(!this.bundleAssignment.exBundle.hasSignature && this.bundleAssignment.finished)
      return true;

    return false;
  }
}
